import React, { memo } from 'react'
import { ConnectButton } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import { faWallet } from '@fortawesome/pro-light-svg-icons'

import { isWalletConnected } from '../../util/walletConnect.helpers'
import CustomButton from '../shared/buttons/CustomButton'

const WalletConnectButtonWrapper = ({ t, customLabel }) => {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openConnectModal,
        authenticationStatus,
        mounted
      }) => {
        const connected = isWalletConnected({
          account,
          chain,
          authenticationStatus,
          mounted
        })
        const handleConnectWallet = () => {
          if (connected) {
            openAccountModal()
          } else {
            openConnectModal()
          }
        }
        return (
          <CustomButton
            icon={faWallet}
            onClick={handleConnectWallet}
            sx={connected && !customLabel && { textTransform: 'none' }}
            label={
              customLabel
                ? customLabel
                : connected
                  ? account.displayName
                  : t('home.connect-wallet')
            }
          />
        )
      }}
    </ConnectButton.Custom>
  )
}

export default memo(WalletConnectButtonWrapper)
